import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {IShippingPlanMarker} from "./PlanMap";

export type THoveredShipping = {
  tracking_number: string;
  status: string;
  complete?: boolean;
};
export const PlansTooltip = ({
                               shippings,
                             }: {
  shippings?: IShippingPlanMarker[];
}) => {
  const {t} = useTranslation("shipping");
  const filtered = useMemo(() => {
    if (shippings && shippings.length > 4) {
      const tmp: {
        [key: string]: {
          [key: string]: {
            count: number,
            complete?: boolean
          }
        }
      } = {}
      shippings.forEach((s) => {
        if (tmp[s.cluster_id]) {
          if (!!tmp[s.cluster_id][s.shipping_item__status || "undefined"]) {
            ++tmp[s.cluster_id][s.shipping_item__status || "undefined"].count;
          }
          else {
            tmp[s.cluster_id][s.shipping_item__status || "undefined"] = {
              count: 1, complete: s.is_scanned
            };
          }
        }
        else {
          tmp[s.cluster_id] = {[s.shipping_item__status || "undefined"]: {count: 1, complete: s.is_scanned}}
        }
      });
      return tmp;
    }
    return;
  }, [shippings]);
  
  if (filtered) {
    return (<div className={"content"}>
      {Object.keys(filtered)
                         .map((sector, i) => {
                           const statusObj = filtered[sector];
                           const statusList = Object.keys(statusObj);
                           return (<div key={"shippinginfo" + i} className={"sector-row"}>
                             <span>{sector}</span>
                             <div className={"column"}>
                               {statusList.map((status) => (<div key={"shippinginfo" + i} className={"row"}>
                                 <span>{t(status)}</span>
                                 <div className={"right"}>
                                   <div
                                     className={"dot " + (statusObj[status].complete)}
                                   />
                                   {t(statusObj[status].count + "")}
                                 </div>
                               </div>))}
                             </div>
                           </div>)
                         })}
    </div>);
  }
  if (shippings && shippings.length) {
    return (<div className={"content"}>
      {shippings && shippings.map((s, i) => (<div key={"shippinginfo" + i} className={"row"}>
        <span className={"bold"}>{s.cluster_id}</span>
        <div className={"right"}>
          <div
            className={"dot " + s.is_scanned}
          />
          {!!s.shipping_item__status && t(s.shipping_item__status)}
        </div>
      </div>))}
    </div>);
  }
  
  return null;
};
